/* User Edit, Vue Component */
<template>
  <v-card v-if="entity && !loading" id="user-edit" class="entity-edit">
    <v-card-title>Edit {{entity.FirstName}} {{entity.LastName}}</v-card-title>

      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <v-alert
          v-if="serverErrorMessage"
          type="error"
        >
          {{ serverErrorMessage }}
        </v-alert>
      </v-card-text>

      <v-card-text class="d-flex align-center flex-wrap pb-0">
      <v-row class="align-center pb-5">
        <v-col>
        <v-btn
          color="primary"
          class="me-3"
          @click="Save"
        >
          <v-icon
            size="18"
            class="me-1"
          >
            {{ icons.mdiContentSaveOutline  }}
          </v-icon>
          <span>Save</span>
        </v-btn>
        </v-col>
        <v-col class="text-right">
        <v-btn
          color="secondary"
          class="me-3"
          @click="Back"
        >
          <v-icon
            size="18"
            class="me-1"
          >
            {{ icons.mdiChevronLeft }}
          </v-icon>
          <span>Back</span>
        </v-btn>
        </v-col>
      </v-row>
      </v-card-text>

      <v-form ref="form">
      <v-simple-table dense>
        <thead>
          <tr>
            <th colspan="2">USER DETAILS</th>
          </tr>
        </thead>
        <tbody>

          <!--<tr>
          <td>Reference</td>
          <td><v-text-field
        label="Reference"
        solo-inverted
        flat
        :error-messages="serverErrors.filter(x => x.field === 'Reference').map(x => x.error)"
        v-model="entity.Reference"
        :rules="[validators.required]"
      ></v-text-field>
  </td>
        </tr>-->

          <tr>
            <td>Email</td>
            <td>
              <v-text-field label="Email"
                            solo-inverted
                            flat
                            :error-messages="serverErrors.filter(x => x.field === 'Email').map(x => x.error)"
                            v-model="entity.Email"
                            :rules="[validators.required]"></v-text-field>
            </td>
          </tr>

          <tr>
            <td>First Name</td>
            <td>
              <v-text-field label="First Name"
                            solo-inverted
                            flat
                            :error-messages="serverErrors.filter(x => x.field === 'FirstName').map(x => x.error)"
                            v-model="entity.FirstName"
                            :rules="[validators.required]"></v-text-field>
            </td>
          </tr>

          <tr>
            <td>Last Name</td>
            <td>
              <v-text-field label="Last Name"
                            solo-inverted
                            flat
                            :error-messages="serverErrors.filter(x => x.field === 'LastName').map(x => x.error)"
                            v-model="entity.LastName"
                            :rules="[validators.required]"></v-text-field>
            </td>
          </tr>

          <tr>
            <td>Role</td>
            <td>
              <!--<v-text-field label="Role"
                            solo-inverted
                            flat
                            :error-messages="serverErrors.filter(x => x.field === 'Role').map(x => x.error)"
                            v-model="entity.Role"
                            :rules="[]"></v-text-field>-->
              <v-select :items="roles" v-model="entity.Role"
                        label="Role"
                              solo-inverted
      flat></v-select>
            </td>
          </tr>

         


          <tr>
            <td>Enabled</td>
            <td><v-checkbox v-model="entity.Enabled" :color="(entity.Enabled ? 'success' : 'secondary')"></v-checkbox></td>
          </tr>
        </tbody>
      </v-simple-table>
      </v-form>

  </v-card>
</template>

<script>
import store from '@/store'
import { useRouter } from '@core/utils'
import * as Display from '@/datahelpers/displayTypes'
import * as FrameworkValidators from '@core/utils/validation'
import * as Validators from '@/datahelpers/validation'
import DateField from '@/views/helpers/DateField'
import CountryLookup from '@/views/country/CountryLookup'

import {
  mdiContentSaveOutline,
  mdiChevronLeft
} from '@mdi/js'
import { ref, watch, computed, expose } from '@vue/composition-api'

export default {
  components: {
    DateField,
    CountryLookup
  },
  setup() {

    const { route, router  } = useRouter();

    const entity = computed(() => {
      return store.state.app.User;
    });
    const loading = ref(false);
    const form = ref(null);
    const serverErrors = ref([]);
    const serverErrorMessage = ref(null);
    const roles = [{ text: 'Super User', value: 'super' }, { text: 'Admin', value: 'admin' }, { text: 'Operations', value: 'ops' }, { text: 'Customer Care', value: 'customercare' }]

    const fetchData = (id) => {
      store
        .dispatch('app/fetchUser', {
          id: id
        })
        .then(response => {
          loading.value = false;
        })
        .catch(error => {
          loading.value = false;
          console.log(error);
          router.push({ name: 'user-list', params: { id: route.value.params.id } });
        })
    }

    // fetch the user information when params change
    watch(() => route.value.params.id, (id) => fetchData(id));

    // and call now
    fetchData(route.value.params.id);


    const Save = function(e) {

      serverErrorMessage.value = null;
      serverErrors.value = [];

      const valid = form.value.validate();

      if (!valid) {
        return;
      }

      loading.value = true;

      store
        .dispatch('app/updateUser', {
          id: route.value.params.id,
          entity: entity.value
        })
        .then(response => {
          loading.value = false;
          router.push({ name: 'user-view', params: { id: response.data.Id } });
        })
        .catch((error) => {
          loading.value = false;
          if (error.error) {
            if (error.message) serverErrorMessage.value = error.message;
            if (error.errors) serverErrors.value = error.errors
          } else {
            console.log(error);
          }
        });
    };

    const Back = () => {
      router.go(-1);
    };

    const validators = {
      ...FrameworkValidators,
      ...Validators
    };

    return {
      Back,
      form,
      Save,
      roles,
      loading,
      entity,
      Display,
      icons: {
        mdiContentSaveOutline ,
        mdiChevronLeft
      },
      validators,
      serverErrorMessage,
      serverErrors
    };
  }
}
</script>

<style lang="scss" scoped>
.entity-edit::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td:last-child {
  padding-right: 0;
}
.entity-edit::v-deep .v-data-table th:last-child {
  width: 66%;
}
.entity-edit::v-deep  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: transparent;
}
.entity-edit::v-deep .v-input:not(.error--text) .v-messages {
  min-height: unset;
}
.entity-edit::v-deep .v-input .v-messages.error--text {
  margin-bottom: 8px;
}
.entity-edit::v-deep .v-input:not(.error--text) .v-text-field__details {
  min-height: unset;
  margin-bottom: 0;
}
.entity-edit::v-deep .v-input:not(.error--text) .v-input__slot {
  margin: 0;
  border-radius: 0;
}
.entity-edit::v-deep .v-input--selection-controls {
  margin: 10px;
}
</style>

